import React from "react";
import CommonButton from "../CommonButton";

interface PetGroomingServiceProps {
    handleBookClick: (id:string) => void;
}

const PetGroomingService: React.FC<PetGroomingServiceProps> = ({
    handleBookClick,
}) => {
    return (
        <div className="rounded-[3rem] overflow-hidden shadow-2xl bg-logoHeading">
            <div className="grid grid-cols-1 md:grid-cols-2 min-h-[400px]">

                {/* Left Content */}
                <div className="flex flex-col justify-center px-8 md:px-12 py-10">
                    <span className="bg-offerColor text-logoHeading text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest w-fit mb-4">
                        Premium Care in UAE
                    </span>

                    <h1 className="text-2xl md:text-4xl font-black text-white leading-tight">
                        Elite Pet Services <br />
                        <span className="text-mainBrandColor">
                            Across Dubai
                        </span>
                    </h1>

                    <p className="text-white/80 mt-4 max-w-md text-base italic">
                        From Jumeirah to Downtown, we bring world-class
                        grooming and veterinary care to your villa doorstep.
                    </p>
                </div>

                {/* Right Image */}
                <div className="relative overflow-hidden group">
                    <img
                        src="https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=1200&q=80"
                        alt="Dubai Pet Grooming"
                        className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                    />

                    {/* Optional gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-logoHeading/20"></div>
                </div>

            </div>
        </div>
    );
};

export default PetGroomingService;